import React, { useMemo, useEffect, Component, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { debounce, Tooltip } from "@material-ui/core";
import { Link, useLocation } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
// import Box from '@mui/material/Box';
// import { makeStyles } from '@material-ui/core/styles';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import { Grid, Paper } from "@material-ui/core";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateQuotation from "./CreateQuotation";
import moment from "moment";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
// import { GridCellParams } from '@mui/x-data-grid';
import { Form } from "formik";
import { Search, Style } from "@material-ui/icons";
import { red } from "@material-ui/core/colors";
import { GridFilterInputValue } from "@mui/x-data-grid";
// import { getOptionsAsync } from "./options";
// import { darken, lighten, styled } from '@mui/material/styles';
// import clsx from 'clsx';
// import { useHistory } from 'react-router-dom';
// import { makeStyles } from "@material-ui/core/styles";




const todate = new Date()
// const Dfromdate = todate.getFullYear() + '/01/01';
// const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 150);
//const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 1);
//const Dfromdate = fromdate;
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 15);
const Dfromdate = fromdate;




const Quotation = () => {
    // debugger;
    // const classes = useStyles();
    const [QuotationNo, setQuotationNo] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [AccName, setAccName] = useState('');
    const [AccountName, setAccountName] = useState('');
    const [AccountOptions, setAccountOptions] = useState([]);
    const [Product, setProduct] = useState([]);
    const [ProductOptions, setProductOptions] = useState([]);
    const [HandelBY, setHandelBY] = useState('');
    const [Status, setStatus] = useState('');
    const [Productcmb, setProductcmb] = useState([]);
    const [ModelNo, setModelNo] = useState('');
    const [City, setCity] = useState('');
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const [QuotationID, setQuotationID] = useState();
    const [Count, setCount] = useState();
    const [ProductName, setProductName] = useState();
    const [ProductID, setProductID] = useState('');
    const [Mode, setMode] = useState('');
    const [ProductIDcmb, setProductIDcmb] = useState([]);
    const [responseProduct, fetchProductData] = UseFetchData();
    const [response, fetchData] = UseFetchData([]);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [SearchMode, setSearchMode] = useState("SEARCH");
    const [cmbPaymentTermsOptions, setcmbPaymentTermsOptions] = useState([]);
    const [cmbACAccount, setcmbACAccount] = useState([]);
    const [cmbLeadSourceData, setcmbLeadSourceData] = useState([]);
    const [cmbCountryData, setcmbCountryData] = useState([]);
    const [cmbCompanyData, setcmbCompanyData] = useState([]);
    const [flagSearch, setflagSearch] = useState(false);
    // const history = useHistory();
    const location = useLocation();



    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const StatusOption = [
        { id: "New", title: "New" },
        { id: "Closed", title: "Closed" },
        { id: "Due", title: "Due" },
        { id: "Expired", title: "Expired" },
        { id: "SalesOrder", title: "SalesOrder" },
    ];

    const ProductData = () => {
        var bodyFormData = new FormData();
        fetchProductData("Quotation/ComboDataQUT", bodyFormData);
    }

    const onProductChange = (event, newValue) => {
        // debugger;
        setProductName(newValue);
        setProductID(newValue.id)
    }

    const onACCChange = (event, newValue) => {
        // debugger;
        setAccountName(newValue);
        setAccountID(newValue.id);
    }

    useEffect(() => {
        ProductData();
        PopulateData();
        // AccountData();
    }, [])

    useEffect(() => {
        // debugger;
        if (responseProduct['cmbProduct'] !== undefined && responseProduct['cmbProduct'].length > 0) {
            setProductOptions(responseProduct['cmbProduct']);
            setAccountOptions(responseProduct['cmbAccount']);
        }
        else {
            setProductOptions([]);
            setAccountOptions([]);
        }
        //
    }, [responseProduct['cmbProduct']]);


    // const GetValue = (value) => {
    //     debugger;
    //     setCity(value);
    // }


    const PopulateData = async (value) => {
        // debugger;
        var AccoName = "";
        // AcName = null;
        var bodyFormData = new FormData();
        if (AccountName !== undefined) {
            AccoName = AccountName.List;
        }
        setSearchMode(SearchMode);
        bodyFormData.append("UserID", sessionStorage.UID);
        bodyFormData.append("UserType", sessionStorage.UserType);
        bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
        // bodyFormData.append("QuotationID", sessionStorage.QuotationID);
        // if (AccountName == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("AccountName", AccoName);
        // }
        // else if (location.state.Account != "" && location.state != undefined) {
        //     var AccountN = location.state.Account;
        //     bodyFormData.append("AccountName", AccountN);
        // }
        // if (City == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("City", City);
        // GetValue(City)
        // }
        // else if (location.state.BCity != "" && location.state != undefined) {
        //     var Citi = location.state.BCity;
        //     bodyFormData.append("City", Citi);
        // }
        // if (HandelBY == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("HandelBY", HandelBY);
        // }
        // else if (location.state.Handelby != "" && location.state != undefined) {
        //     var HBY = location.state.Handelby;
        //     bodyFormData.append("HandelBY", HBY);
        // }
        if (FromDate == undefined) {
            bodyFormData.append("FromDate", Moment(Dfromdate).format('YYYY-MM-DD'));
        }
        else {
            bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        }
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        // if (QuotationNo == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("QuotationNo", QuotationNo);
        // }
        // else if (location.state.Qno != "" && location.state != undefined) {
        //     var Qno = location.state.Qno;
        //     bodyFormData.append("QuotationNo", Qno);
        // }
        // if (Status == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("QuotationStage", Status);
        // }
        // else if (location.state.status != "" && location.state != undefined) {
        //     var QStage = location.state.status;
        //     bodyFormData.append("QuotationStage", QStage);
        // }
        // if (ProductID == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("ProductID", ProductID);
        // }
        // else if (location.state.PID != "" && location.state != undefined) {
        //     var ProID = location.state.PID;
        //     bodyFormData.append("ProductID", ProID);
        // }
        // if (ModelNo == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("ModelCode", ModelNo);
        // }
        // else if (location.state.Mc != "" && location.state != undefined) {
        //     var Modelc = location.state.Mc;
        //     bodyFormData.append("ModelCode", Modelc);
        // }
        await fetchData("Quotation/List", bodyFormData);
    };




    const handleOpenModal = () => {
        setQuotationID('');
        setMode('Insert');
        setOpen(true);
    };

    // const useStyles = makeStyles({
    //     oddRow: {
    //         backgroundColor: '#f2f2f2'
    //     },
    //     evenRow: {
    //         backgroundColor: '#ffffff'
    //     }
    // });
    // const openModal = (params) => {
    //     debugger;
    //     // if (params.id == "") {
    //     history.push(`/quotation/${params.row.AccountName}/QuotationView`);
    //     // }
    // };
    // export default function DataGridExample({ data }) {

    useEffect(() => {
        debugger;
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                renderCell: (params) => (<strong> <Link to={{ pathname: "/quotation/QuotationView", state: { QuotationID: params.id, Status, AccountName: AccountName.List, City, HandelBY, ProductID, ModelNo, QuotationNo } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                //renderCell: (params) => (<strong> <Link to={{ pathname: "/quotation/QuotationView", state: { QuotationID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "QuotationNo",
                headerName: "Qut No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,

            },
            {
                field: "QuotationDate",
                headerName: "Qut Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
                valueFormatter: params =>
                    moment(params?.value).format("DD/MM/YYYY"),
            },
            {
                field: "AccountName",
                headerName: "Account Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
                renderCell: (params) => (
                    <Tooltip title={params.row.AccountName} >
                        <span className="table-cell-trucate">{params.row.AccountName}</span>
                    </Tooltip>
                )
            },
            {
                field: "ContactName",
                headerName: "Contact Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },
            // {
            //     field: "LeadSource",
            //     headerName: "Source",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 150,
            // },
            {
                field: "QuotationStage",
                headerName: "Stage",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                // type: Text,
                width: 150,
                renderCell: (params) => {
                    const status = params.row.QuotationStage;
                    const color = status === 'Expired' ? 'red' : 'inherit';
                    return <span style={{ color }}>{status}</span>;
                },
            },
            {
                field: "ValidUpTo",
                headerName: "ValideUpTo",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "ModifiedBy",
                headerName: "Handel By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "PredictedClosingDate",
                headerName: "E.D.C",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "BillCity",
                headerName: "Bill City",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "BillCountry",
                headerName: "Bill Country",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "BillState",
                headerName: "Bill State",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "CreatedBy",
                headerName: "Created By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "ModifiedBy",
                headerName: "Modified By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            // row = {
            //     backgroundColor: '#f2f2f2',
            // },
        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
    }, [response]);


    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['QuotationNo', 'QuotationDate', 'AccountName', 'ContactName', 'LeadSource', 'QuotationStage', 'ValidUpTo', 'ModifiedBy', 'PredictedClosingDate', 'BillCity', 'BillCountry', 'BillState', 'CreatedBy', 'ModifiedBy'],
                }} />
            </GridToolbarContainer>
        );
    }



    // const getBackgroundColor = (color, mode) =>
    //     mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

    // const getHoverBackgroundColor = (color, mode) =>
    //     mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    // const getSelectedBackgroundColor = (color, mode) =>
    //     mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

    // const getSelectedHoverBackgroundColor = (color, mode) =>
    //     mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);


    // const DataGrid = styled(DataGrid)(({ theme }) => ({
    //     '& .super-app-theme--New': {
    //         backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
    //         '&:hover': {
    //             backgroundColor: getHoverBackgroundColor(
    //                 theme.palette.info.main,
    //                 theme.palette.mode,
    //             ),
    //         },
    //         '&.Mui-selected': {
    //             backgroundColor: getSelectedBackgroundColor(
    //                 theme.palette.info.main,
    //                 theme.palette.mode,
    //             ),
    //             '&:hover': {
    //                 backgroundColor: getSelectedHoverBackgroundColor(
    //                     theme.palette.info.main,
    //                     theme.palette.mode,
    //                 ),
    //             },
    //         },
    //     },
    //     '& .super-app-theme--Expired': {
    //         backgroundColor: getBackgroundColor(
    //             theme.palette.success.main,
    //             theme.palette.mode,
    //         ),
    //         '&:hover': {
    //             backgroundColor: getHoverBackgroundColor(
    //                 theme.palette.success.main,
    //                 theme.palette.mode,
    //             ),
    //         },
    //         '&.Mui-selected': {
    //             backgroundColor: getSelectedBackgroundColor(
    //                 theme.palette.success.main,
    //                 theme.palette.mode,
    //             ),
    //             '&:hover': {
    //                 backgroundColor: getSelectedHoverBackgroundColor(
    //                     theme.palette.success.main,
    //                     theme.palette.mode,
    //                 ),
    //             },
    //         },
    //     },
    // }));

    // const getStatusRowClassName = (params) => {
    //     if (params.row.QuotationStage === 'Expired') {
    //         // return 'expiredrow';
    //         return useStyles;
    //     }
    //     return '';
    // };

    // const getRowStyle = () => {
    //     // if (params.row.QuotationStage === 'Expired') {
    //     //     return { backgroundColor: 'Green' };
    //     // }
    //     return { backgroundcolor: 'red' };
    // };

    // const getRowBackgroundColor = () => {
    //     debugger;
    //     return 'Rowcolor';
    // };


    // const getRowClassName = (params) => {
    //     debugger;
    //     if (params.row.QuotationStage === "Expired") { // check if the row is the second row
    //         return 'highlighte'; // return the class name for the highlighted row
    //     }
    //     return ''; // return an empty string for all other rows
    // }

    const onSelectChange = (e) => {
        debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "City") {
                setCity(targetvalue);
            }
            if (targetname === "ModelNo") {
                setModelNo(targetvalue);
            }
            if (targetname === "QuotationNo") {
                setQuotationNo(targetvalue);
            }
            if (targetname === "Status") {
                setStatus(targetvalue);
            }
            if (targetname === "HandelBY") {
                setHandelBY(targetvalue);
            }

        } else {
            if (targetname === "City") {
                setCity('');
            }
            if (targetname === "ModelNo") {
                setModelNo('');
            }
            if (targetname === "QuotationNo") {
                setQuotationNo('');
            }
            if (targetname === "Status") {
                setStatus('');
            }
            if (targetname === "HandelBY") {
                setHandelBY('');
            }
        }
    };

    return <div >
        <Grid container direction="row" style={{ marginTop: -10 }} >
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 28, paddingTop: 0, paddingBottom: 0, marginRight: 40 }}>
                <BiztranControls.Autocomplete
                    label="Product"
                    style={{ marginLeft: 8, width: "250px" }}
                    options={ProductOptions}
                    onChange={debounce(onProductChange, 300)}
                    value={Product}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }} >
                <BiztranControls.Input
                    label="Model No"
                    id="ModelNo"
                    style={{ width: "180px" }}
                    onChange={(e) => setModelNo(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
                <BiztranControls.Input
                    label="Quotation No"
                    id="QuotationNo"
                    value={QuotationNo}
                    style={{ width: "180px" }}
                    onChange={(e) => setQuotationNo(e.target.value)}

                />
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
                <BiztranControls.Select
                    label="Status"
                    id="Status"
                    style={{ width: "180px" }}
                    options={StatusOption}
                    onChange={(e) => setStatus(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
                <BiztranControls.Input
                    label="Prepared BY"
                    id="HandelBY"
                    style={{ width: "180px" }}
                    onChange={(e) => setHandelBY(e.target.value)}
                />
            </Grid>
        </Grid>
        <Grid container direction="row" style={{ marginTop: 0 }}>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 23, paddingTop: 0, paddingBottom: 0, marginRight: 40 }}>
                <BiztranControls.Autocomplete
                    label="Account Name"
                    style={{ marginLeft: 8, width: "250px" }}
                    options={AccountOptions}
                    onChange={onACCChange}
                    value={AccName}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 15 }}>
                <BiztranControls.Input
                    label="City"
                    id="city"
                    style={{ width: "180px" }}
                    onChange={(e) => setCity(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 3 }}>
                <div style={{ width: "180px", marginLeft: 6 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </div>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 3 }}>
                <div style={{ width: "180px", marginLeft: 8 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </div>
            </Grid>
            <Grid xs={6} md={4} sm={8} lg={4} xl={3} style={{ marginLeft: -40 }}>
                <div style={{ width: "100%" }} >
                    <div style={{ float: "left", marginTop: 3, width: "30%" }}>
                        <BiztranControls.Button
                            responsive="true"
                            text="SEARCH"
                            startIcon={<SearchIcon />}
                            style={{ marginTop: '16%' }}
                            onClick={() => {
                                PopulateData('SEARCH');
                                setflagSearch(true);
                            }}

                        />
                    </div>
                    <div style={{ float: "left", marginTop: 30, marginLeft: 7 }}>
                        <label style={{ fontWeight: 'bold', width: 7 }}>{Count}</label>
                    </div>
                    <div style={{ float: "left", marginTop: 2, width: "30%" }}>
                        <BiztranControls.Button
                            responsive="true"
                            text="ADD NEW"
                            startIcon={<AddCircleOutlineIcon />}
                            style={{ marginTop: '16%' }}
                            onClick={() => {
                                handleOpenModal();
                            }}
                        />
                    </div>
                </div>
            </Grid>
        </Grid>

        {/* <Box
            sx={{
                height: 300,
                width: '100%',
                '& .Expired': {
                    backgroundColor: '#b9d5ff91',
                    color: '#1a3e72',
                },
            }}
        > */}
        {/* <TableRow className={index % 2 ? classes.oddRow : classes.evenRow}> */}
        {/* your row contents here */}
        {/* </TableRow> */}


        {/* <Box
            sx={{
                height: 400,
                width: '100%',
                '& .super-app-theme--Expired': {
                    bgcolor: (theme) =>
                        getBackgroundColor(theme.palette.info.main, theme.palette.mode),
                    '&:hover': {
                        bgcolor: (theme) =>
                            getHoverBackgroundColor(theme.palette.info.main, theme.palette.mode),
                    },
                // }


            }}
        > */}
        {/* <Box
            sx={{
                height: 300,
                width: '100%',
                '& .cold': {
                    backgroundColor: '#b9d5ff91',
                    color: '#1a3e72',
                },
                '& .hot': {
                    backgroundColor: '#ff943975',
                    color: '#1a3e72',
                },
            }}
        > */}
        <BiztranControls.DataGrid
            // style={{ color: '#EEF1F6', }}
            headerHeight={32}
            rowHeight={23}
            rows={rows}
            columns={columns}
            // getRowStyle={getRowStyle}
            // getRowClassName={getRowBackgroundColor}
            // getRowClassName={(params) => `super-app-theme--${params.row.status}`}
            // getCellClassName={(params) => {
            //     if (params.row.QuotationStage === 'New' || params.row.QuotationStage == null) {
            //         return '';
            //     }
            //     return params.row.QuotationStage === "Expired" ? 'hot' : 'cold';
            // }}
            AutoSizeRowsMode={true}
            checkboxSelection={false}
            //autoHeight={true}
            Height="500px"
            Width="100%"
            components={{ Toolbar: CustomToolbar, }}
        // {...response}
        />
        {/* </Box> */}


        <ModalFrame
            title="Quotation Details"
            maxWidth="md"
            isOpen={isOpen}
            setOpen={setOpen}
        >
            <CreateQuotation
                Mode={Mode}
                AccountName={AccName}
                setOpen={setOpen}
                PopulateData={PopulateData}
                cmbACAccount={cmbACAccount}
                cmbLeadSourceData={cmbLeadSourceData}
                cmbCountryData={cmbCountryData}
                cmbPaymentTermsOptions={cmbPaymentTermsOptions}
                cmbCompanyData={cmbCompanyData}
            />
        </ModalFrame>

    </div>;
};




// const useStyles = makeStyles((theme) => ({

//     expiredrow: {
//         backgroundcolor: "'#FFCDD2",
//     },
//     Rowcolor: {
//         backgroundcolor: 'Red',
//     },

// }));

export default Quotation;